import React from 'react';
import { useSelector } from 'react-redux';
import { Badge, Button, RegularButton, Icon, ResetIcon, Typography } from 'fronton-react';
import { getFoundCardsNumber, getCategoriesNumberText, getAdditionalText } from 'utils';
import { ModalContainer } from 'common/components';
import { selectIsSmallScreen } from 'store/pageStore';
import { FilterModal } from '../filter-modal';
import { useHeader } from './hooks';

import {
	BadgeStyles,
	FilterBtnStyles,
	FilterBtnWrapper,
	HeaderBtnsWrapper,
	HeaderWrapper,
} from './styles';

export const Header = () => {
	const isSmallScreen = useSelector(selectIsSmallScreen);

	const {
		selectedFilterItems,
		topCategories,
		resetSelectedFilterItems,
		isModalOpen,
		openModal,
		closeModal,
	} = useHeader();

	const foundCardsNumber = getFoundCardsNumber(topCategories, selectedFilterItems);
	const categoriesNumberText = `${getAdditionalText(
		foundCardsNumber
	)} ${foundCardsNumber} ${getCategoriesNumberText(foundCardsNumber)}`;

	return (
		<HeaderWrapper>
			{isSmallScreen && (
				<HeaderBtnsWrapper>
					<FilterBtnWrapper>
						<Button
							kind="regular"
							size="m"
							variant="secondary"
							className={FilterBtnStyles}
							onClick={openModal}
							data-qa="header__filter-btn"
						>
							Фильтры
						</Button>
						{selectedFilterItems.length !== 0 && (
							<Badge
								type="secondary"
								value={selectedFilterItems.length}
								className={BadgeStyles}
								data-qa="header__filter-badge"
							/>
						)}
					</FilterBtnWrapper>
					{selectedFilterItems.length !== 0 && (
						<RegularButton
							size="m"
							variant="outline"
							className={FilterBtnStyles}
							onClick={resetSelectedFilterItems}
							data-qa="header__reset-btn"
						>
							<Icon size={12}>
								<ResetIcon />
							</Icon>
							Сбросить все
						</RegularButton>
					)}
				</HeaderBtnsWrapper>
			)}
			<Typography
				variant={isSmallScreen ? 's' : 'm'}
				size="body_short"
				data-qa="header__categories-number"
			>
				{categoriesNumberText}
			</Typography>
			<ModalContainer isOpen={isModalOpen} onClose={closeModal}>
				<FilterModal />
			</ModalContainer>
		</HeaderWrapper>
	);
};
